// Styles for NGSearchFormABTestWrapper go here.
import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

interface SkeletonLoaderFormContainerProps {
  topOffset: string;
  topOffsetXs?: string;
  topOffsetSm?: string;
  topOffsetMd?: string;
  topOffsetLg?: string;
  isSkeletonSticky?: boolean;
  skeletonStickyTop?: string;
}

export const StyledSkeletonLoaderFormContainer = styled.div<SkeletonLoaderFormContainerProps>`
  ${rtl`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: ${toRem(24)};
    padding-bottom: ${toRem(0)};
    
    &.search-form-position {
      position: ${({ isSkeletonSticky }: SkeletonLoaderFormContainerProps) =>
        isSkeletonSticky ? 'fixed' : 'absolute'};
      width: 100%;
      left: 0;
      right: 0;
      top: ${({ topOffset, topOffsetXs, isSkeletonSticky, skeletonStickyTop }: SkeletonLoaderFormContainerProps) =>
        isSkeletonSticky && skeletonStickyTop ? skeletonStickyTop : topOffsetXs ?? topOffset};
      padding-top: ${toRem(24)};
      padding-bottom: 0;
      z-index: 49;
      ${({ isSkeletonSticky }: SkeletonLoaderFormContainerProps) =>
        isSkeletonSticky ? 'transition: top 0.4s ease 0s;' : ''}

      @media ${baseVariables.mediaQuery.sm} {
        top: ${({
          topOffset,
          topOffsetSm,
          topOffsetXs,
          isSkeletonSticky,
          skeletonStickyTop,
        }: SkeletonLoaderFormContainerProps) =>
          isSkeletonSticky && skeletonStickyTop ? skeletonStickyTop : topOffsetSm ?? topOffsetXs ?? topOffset};
        left: 0;
        right: 0;
      }

      @media ${baseVariables.mediaQuery.md} {
        top: ${({
          topOffset,
          topOffsetMd,
          topOffsetSm,
          isSkeletonSticky,
          skeletonStickyTop,
        }: SkeletonLoaderFormContainerProps) =>
          isSkeletonSticky && skeletonStickyTop ? skeletonStickyTop : topOffsetMd ?? topOffsetSm ?? topOffset};
        left: 0;
        right: 0;
      }

      @media ${baseVariables.mediaQuery.lg} {
        top: ${({
          topOffset,
          topOffsetLg,
          topOffsetMd,
          isSkeletonSticky,
          skeletonStickyTop,
        }: SkeletonLoaderFormContainerProps) =>
          isSkeletonSticky && skeletonStickyTop ? skeletonStickyTop : topOffsetLg ?? topOffsetMd ?? topOffset};
        z-index: 49;
      }
    }
    
    .search-form-wrapper {
      width: 100%;
      max-width: 100%;
      margin: 0 auto;
      padding: 0 ${toRem(16)};
      box-sizing: border-box;

      @media ${baseVariables.mediaQuery.sm} {
        padding: 0 ${toRem(8)};
      }

      @media ${baseVariables.mediaQuery.desktop} {
        padding: 0;
        max-width: ${toRem(1140)};
        margin: 0 auto;
      }
      
      .search-form-skeleton {
        width: 100%;
        height: ${toRem(56)};
        border-radius: ${toRem(8)};
        background-color: ${baseVariables.color['light-gray-1']};
        overflow: hidden;
        position: relative;
        box-shadow: 0 ${toRem(8)} ${toRem(20)} 0 rgba(0, 0, 0, 0.1);
        
        @media ${baseVariables.mediaQuery.md} {
          height: ${toRem(92)};
          border-radius: ${toRem(12)};
        }
        
        @media ${baseVariables.mediaQuery.lg} {
          border-radius: ${toRem(16)};
          height: ${toRem(92)};
          box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
        }
        
        .skeleton-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0.3;
          -webkit-animation: fadein 2s ease-in alternate infinite;
          -moz-animation: fadein 2s ease-in alternate infinite;
          animation: fadein 2s ease-in alternate infinite;
        }
      }
    }
    
    /* When overlay, use same container width as baseline searchform */
    &.search-form-position .search-form-wrapper {
      max-width: ${toRem(1140)};
      margin: 0 auto;
      padding: 0 ${toRem(16)};

      @media ${baseVariables.mediaQuery.sm} {
        padding: 0 ${toRem(8)};
      }

      @media ${baseVariables.mediaQuery.desktop} {
        padding: 0;
      }
    }
    
    @-webkit-keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
    @-moz-keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
    @keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
  `}
`;

export const StyledSkeletonLoaderDiv = styled.div`
  ${rtl`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;
